module.exports = __webpack_public_path__ + "d0885559.svg";